import PricingBreakdownOffers from './PricingBreakdownOffers';

export default PricingBreakdownOffers;
